import { Resource, FamilyMemberHistory } from '@medplum/fhirtypes'

type Props = {
  resource?: Resource
}

const availFields = [
  { code: 'relationship', title: 'Family Member' },
  { code: 'doctor', title: 'Doctor' },
  { code: 'condition', title: 'Problem(s)' },
]

const getDoctor = (history: FamilyMemberHistory) => {
  if (Array.isArray(history.extension)) {
    const doctorExt = history.extension.find(
      (e) =>
        e.url?.toLowerCase().includes('doctor') ||
        e.url?.toLowerCase().includes('practitioner') ||
        e.url?.toLowerCase().includes('provider'),
    )
    if (doctorExt?.valueReference?.display) return doctorExt.valueReference.display
    if (doctorExt?.valueReference?.reference) return doctorExt.valueReference.reference
  }
  return ''
}

const renderColumn = (history: FamilyMemberHistory, itemCode: string) => {
  switch (itemCode) {
    case 'relationship':
      return (
        <div>
          <div>
            {history.name ||
              history.relationship?.text ||
              history.relationship?.coding?.[0]?.display ||
              '-'}
          </div>
          {history.deceasedBoolean && <div className="text-xs text-gray-400">Deceased</div>}
        </div>
      )
    case 'doctor':
      return getDoctor(history)
    case 'condition':
      return (
        <div>
          {history.condition?.length
            ? history.condition.map((item, idx) => <div key={idx}>{item.code?.text || '-'}</div>)
            : 'n/a'}
        </div>
      )
    default:
      return ''
  }
}

export function FamilyHistory({ resource }: Props) {
  const history = resource as FamilyMemberHistory

  if (!history) {
    return null
  }

  return (
    <div className="border-b-1 border-b-gray-200 pb-2">
      <table className="text-base">
        <tbody>
          {availFields.map((item) => (
            <tr>
              <td className="py-1 text-sm font-bold text-[#7D7987]">{item.title}:</td>
              <td className="px-[8px] py-1 text-base text-sm">
                <div>{renderColumn(history, item.code)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
